import React from 'react';

import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';

import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';

export type InfoCardProps = {
  imageUrl: string;
  title: string;
  content: string;
};

export default function InfoCard({ imageUrl, title, content }: InfoCardProps) {
  const imageFromCDN = getCdnImageUrl(720, imageUrl, CDN_URL);

  return (
    <div className="flex flex-col items-center justify-center gap-6 max-w-288 text-rp-neutral">
      <ImageLoaded url={imageFromCDN} height="116" width="116" alt="info card image" />
      <h1 className="text-xl text-center">{title}</h1>
      <p className="text-center text-sm">{content}</p>
    </div>
  );
}
